import Icon from "@material-ui/core/Icon"
import React from "react"

import {
  FlightTableTab,
  IFlightTableSelection,
  updateChosenFlighTableTabSelection
} from "../../containers/selectionSlice"

import Button from "../generic/buttons/Button"
import { ReactComponent as TabCondensedIcon } from "../../img/icons/table_view_condensed_icon.svg"
import { useAppDispatch, useAppSelector } from "../../app/hooks"

export interface ActionButton {
  label: string
  title: string
  disabled: boolean
  onClick: () => void
}

export interface DataEditTableTopBarProps {
  actions: ActionButton[]
}

export const DataEditTableTopBar: React.FunctionComponent<
  DataEditTableTopBarProps
> = ({ actions }) => {
  const dispatch = useAppDispatch()

  const { chosenFlightTableTab }: IFlightTableSelection = useAppSelector(
    (state) => state["selectionReducer"].flightTableSelection
  )

  const handleChangeTab = (tab: FlightTableTab) => {
    dispatch(updateChosenFlighTableTabSelection(tab))
  }

  const actionButtons = actions.map((action, idx) => (
    <Button
      key={idx}
      className="ocs-btn-link"
      onClick={action.onClick}
      title={action.title}
      disabled={action.disabled}
    >
      {action.label}
    </Button>
  ))

  return (
    <div className="ocs-flight-table-top-bar d-flex flex-column">
      <section className={"ocs-flight-table-top-bar-btn "}>
        <div className="d-flex ocs-action-btns">
          <div className="d-flex ocs-action-btns-wrapper">{actionButtons}</div>
        </div>
        <div className="d-flex ocs-flight-table-top-bar-btn">
          <div className="ocs-flight-table-tabs mq-flex-direction-row  d-flex">
            <div
              className={
                "ocs-flight-table-tab ocs-mr-6" +
                (chosenFlightTableTab === FlightTableTab.condensed
                  ? " ocs-flight-table-tab-active"
                  : "")
              }
              onClick={() => {
                handleChangeTab(FlightTableTab.condensed)
              }}
            >
              <TabCondensedIcon className="ocs-flight-table-tab-icon" />
            </div>
            <div
              className={
                "ocs-flight-table-tab ocs-mr-4" +
                (chosenFlightTableTab === FlightTableTab.default
                  ? " ocs-flight-table-tab-active"
                  : "")
              }
              onClick={() => {
                handleChangeTab(FlightTableTab.default)
              }}
            >
              <Icon className="ocs-md-btn-icon ocs-flight-table-tab-icon">
                grid_on
              </Icon>
            </div>
            <div
              className={
                "ocs-flight-table-tab " +
                (chosenFlightTableTab === FlightTableTab.spacious
                  ? " ocs-flight-table-tab-active"
                  : "")
              }
              onClick={() => {
                handleChangeTab(FlightTableTab.spacious)
              }}
            >
              <Icon className="ocs-md-btn-icon ocs-flight-table-tab-icon">
                window
              </Icon>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

